
(function () {
  'use strict';

  const hoverQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  function initUGC(root) {
    if (root.dataset.ugcReady === 'true') return;
    root.dataset.ugcReady = 'true';

    const triggers = Array.from(
      root.querySelectorAll('[data-kc-ugc-open]')
    );

    const dialog = root.querySelector('[data-kc-ugc-dialog]');
    if (!dialog || !triggers.length) return;

    const slides = Array.from(
      dialog.querySelectorAll('[data-kc-ugc-slide]')
    );

    const closeButton = dialog.querySelector('[data-kc-ugc-close]');
    const previousButton = dialog.querySelector('[data-kc-ugc-prev]');
    const nextButton = dialog.querySelector('[data-kc-ugc-next]');
    const counter = dialog.querySelector('[data-kc-ugc-counter]');

    let currentIndex = 0;
    let activePreview = null;

    function stopPreview(trigger) {
      if (!trigger) return;

      const video = trigger.querySelector('video');
      if (!video) return;

      video.pause();
      try {
        video.currentTime = 0;
      } catch (error) {}

      trigger.classList.remove('is-playing');

      if (activePreview === trigger) {
        activePreview = null;
      }
    }

    function stopAllPreviews() {
      triggers.forEach(stopPreview);
    }

    function stopAllPlayers() {
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (!video) return;

        video.pause();
        video.muted = true;

        try {
          video.currentTime = 0;
        } catch (error) {}
      });
    }

    function showVideo(index) {
      if (!slides.length) return;

      stopAllPlayers();

      currentIndex = (
        index + slides.length
      ) % slides.length;

      slides.forEach((slide, i) => {
        slide.hidden = i !== currentIndex;
      });

      if (counter) {
        counter.textContent =
          (currentIndex + 1) + ' / ' + slides.length;
      }

      const player = slides[currentIndex].querySelector('video');
      if (!player) return;

      player.muted = false;
      player.volume = 1;

      const playPromise = player.play();

      if (playPromise) {
        playPromise.catch(() => {
          // Browser อาจต้องการให้กด Play จาก controls
        });
      }
    }

    function openPopup(index) {
      stopAllPreviews();

      if (!dialog.open) {
        dialog.showModal();
      }

      showVideo(index);
    }

    function closePopup() {
      if (dialog.open) dialog.close();
    }

    triggers.forEach((trigger, index) => {
      const preview = trigger.querySelector('video');
      if (!preview) return;

      trigger.addEventListener('mouseenter', () => {
        if (!hoverQuery.matches || dialog.open) return;

        stopAllPreviews();
        activePreview = trigger;

        preview.muted = true;

        const playPromise = preview.play();

        if (playPromise) {
          playPromise.then(() => {
            if (
              activePreview === trigger &&
              trigger.matches(':hover') &&
              !dialog.open
            ) {
              trigger.classList.add('is-playing');
            } else {
              stopPreview(trigger);
            }
          }).catch(() => {
            stopPreview(trigger);
          });
        }
      });

      trigger.addEventListener('mouseleave', () => {
        stopPreview(trigger);
      });

      trigger.addEventListener('click', () => {
        openPopup(index);
      });
    });

    closeButton?.addEventListener('click', closePopup);

    previousButton?.addEventListener('click', () => {
      showVideo(currentIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      showVideo(currentIndex + 1);
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closePopup();
      }
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.target.closest('video')) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showVideo(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showVideo(currentIndex + 1);
      }
    });

/* Mobile Swipe Navigation */

const swipeArea = dialog.querySelector('.kc-ugc__slides');

if (swipeArea) {
  let startX = 0;
  let startY = 0;

  swipeArea.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1) return;

    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });

  swipeArea.addEventListener('touchend', (event) => {
    if (event.changedTouches.length !== 1) return;

    const deltaX = event.changedTouches[0].clientX - startX;
    const deltaY = event.changedTouches[0].clientY - startY;

    if (
      Math.abs(deltaX) < 60 ||
      Math.abs(deltaX) <= Math.abs(deltaY) * 1.3
    ) {
      return;
    }

    if (deltaX < 0) {
      showVideo(currentIndex + 1);
    } else {
      showVideo(currentIndex - 1);
    }
  }, { passive: true });
}

    dialog.addEventListener('close', () => {
      stopAllPlayers();
      stopAllPreviews();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAllPreviews();

        if (dialog.open) {
          const player = slides[currentIndex]?.querySelector('video');
          player?.pause();
        }
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-kc-ugc]').forEach(initUGC);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
